define([
    "jquery",
    "underscore",
    "backbone",
    "i18next/i18next",
    ], function($, _, Backbone, i18n) {
        "use strict";

        var ContactModel = Backbone.Model.extend({
            url: function() {
                return App.urlTo("site/contact");
            },

            defaults: {
                name    : "",
                email   : "",
                phone   : "",
                address : "",
                company : "",
                site    : "",
                contact : "",
                sector  : "",
                employees: "",
                comment : "",
                landing : "",
                reCaptcha : "",
                type : "",
                accept_contact_conditions: 0,
            },

            validation: {
                email: [ {
                    required: true,
                    msg: function() {
                        return i18n.t("contact.email_required");
                    }
                }, {
                    pattern: "mail",
                    msg: function() { return i18n.t("validation.invalid_email"); }
                } ],
                name: [ {
                    required: true,
                    msg: function() { return i18n.t("contact.name_required"); }
                } ],
                phone: [{
                    required: true,
                    msg: function() {
                        return i18n.t('validation.phone_required')
                    },
                }, {
                    rangeLength: [9, 20],
                    msg: function() {
                        return i18n.t('validation.phone_length')
                    },
                }, {
                    pattern: 'phone',
                    msg: function() {
                        return i18n.t('validation.phone_invalid')
                    },
                } ],
                company: [ {
                    required: true,
                    msg: function() { return i18n.t("contact.company_required"); }
                } ],
                address: [ {
                    required: true,
                    msg: function() { return i18n.t("contact.address_required"); }
                } ],
                employees: [ {
                    required: true,
                    msg: function() { return i18n.t("contact.employees_required"); }
                } ],
                contact: [ {
                    required: true,
                    msg: function() { return i18n.t("contact.contact_required"); }
                } ],
                accept_contact_conditions: [{
                    fn: "acceptConditions"
                }]
            },

            acceptConditions: function(val) {
                if (val !== true) {
                    return i18n.t("contact.accept_conditions_required");
                }
            },

            initialize: function() {}

        });

        return ContactModel;

    });
